import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SocialAuthService } from 'angularx-social-login'; 
import { StorageService } from 'src/app/services/storage.service';
import { UsuarioService } from 'src/app/services/usuario.service';
import { ApiService } from 'src/app/services/api.service';
import { AppService } from 'src/app/services/app.service';
import { Router } from '@angular/router';

@Component({
  selector: 'usuario-logado-modal',
  templateUrl: './usuario-logado-modal.component.html',
  styleUrls: ['./usuario-logado-modal.component.scss']
})
export class UsuarioLogadoModal implements OnInit {

  public usuario:any = {};
  public loader      = false;

  constructor(
    public dialog: MatDialogRef<UsuarioLogadoModal>,
    @Inject(MAT_DIALOG_DATA) public data,
    private authService: SocialAuthService,
    private storage: StorageService,
    private usuarioService: UsuarioService ,
    private api: ApiService,
    private app: AppService,
    private route: Router
  ){

    this.usuario = this.data.usuario;

  }
  /**
   * 
   * Close
   * 
   */
  _close(){

    this.dialog.close();  

  }
  /**
   * 
   * Sair
   * 
   */
  _sair(){

    /**if(this.usuario.provider == "GOOGLE" || this.usuario.provider == "FACEBOOK"){

      this.storage.removeUsuario();
      this.usuario = null;
      this.usuarioService.emitUsuarioLogin.emit(null); 
      this._close(); 

    }else{*/

      this.loader = true; 
      
      this.api.loja().logout().subscribe(response => {

        this.loader =  false;

        if(response.status == 1){
          console.log(response); 
          this.usuarioService.emitUsuarioLogin.emit(null); 
          this._close(); 
          this.storage.removeUsuario();
          this.usuario = null; 
                    

        }else{

          this.app.info("Houve um problema ao sair. Tente novamente ou entre em contato com a nossa equipe.","danger");

        }

      }, (response) => {

        this.loader = false;
        let errors  = this.app.formatError(response);

        this.app.formatError(errors.message);

      });

    //}

  }
  /**
   * 
   * To Route
   * 
   */
  toMinhasViagens(){

    this._close();
    this.route.navigateByUrl("/minhas-viagens"); 

  }
  /**
   * 
   * Inicializa as funções
   * 
   **/
  ngOnInit():void{}

}
